<script lang="ts">
	import error from '$lib/assets/error.svg';
	import warning from '$lib/assets/paymentRequired.svg';

	export let title = 'Sorry, we hit a snag';
	export let message = 'We can’t access the offer from the link you clicked.';
	export let handleError = () => {};
	export let removeButton = false;
	export let buttonText = 'Contact your representative';
	export let type: 'error' | 'warning' = 'warning';
	export let disableClickOutside = false;

	function clickOutside(element: HTMLElement, callbackFunction: Function) {
		if (!disableClickOutside) {
			function onClick(event: MouseEvent) {
				const targetNode = event.target as Node;
				if (targetNode && !element.contains(targetNode)) {
					callbackFunction();
				}
			}

			document.body.addEventListener('click', onClick);

			return {
				update(newCallbackFunction: Function) {
					callbackFunction = newCallbackFunction;
				},
				destroy() {
					document.body.removeEventListener('click', onClick);
				}
			};
		}
	}
</script>

<div class="fixed top-0 left-0 w-full h-full z-[1000] bg-black bg-opacity-20">
	<div
		use:clickOutside={() => handleError()}
		class="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-[#FFF] w-[90%] sm:w-[518px] p-8 flex gap-6 flex-col items-center justify-center rounded-xl"
	>
		<img src={type === 'error' ? error : warning} alt="error" />
		<div class="flex flex-col gap-6 items-center text-center">
			<p class="text-2xl">{title}</p>
			<p class="text-xl">
				{message}
			</p>
		</div>
		{#if !removeButton}
			<button
				style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);"
				class="bg-[#F79120] text-[#FFF] min-w-[165px] h-[56px] rounded-md text-xl px-4"
				on:click={handleError}
			>
				{buttonText}
			</button>
		{/if}
	</div>
</div>
